import { createTheme } from '@mui/material/styles';

let primaryFontFamily = 'DM Sans, Montserrat';
let secondaryFontFamily = 'DM Sans, Montserrat';
let white = '#000';
let primaryColor = '#fc5d5d';
let secondaryColor = '#6f4894';
let dropdownColor = '#6f4894';
let btnBackGround = '#dbdad9';
let navUnderline = '#6f4894';

const themeEVC = createTheme({
  palette: {
    button: {
      main: primaryColor,
      secondary: secondaryColor,
    },
    field: {
      main: primaryColor,
      secondary: secondaryColor,
    },
    btnBackgroundColor: btnBackGround,
    btnActiveColor: secondaryColor,
    btnHoverTxt: white,
    btnHoverColor: secondaryColor,
    dropdownColor: dropdownColor,
    underline: navUnderline,
  },
  typography: {
    fontFamily: primaryFontFamily,
    secondaryFontFamily: secondaryFontFamily,
  },
});
export default themeEVC;
